(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cw-built-header"]) return;
  try {
    
  class CwMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.cwh-nav-trigger');
      this.panel = this.querySelector('.cwh-mega-panel');
      this.openTimer = null;
      this.closeTimer = null;
    }

    connectedCallback() {
      this.trigger.addEventListener('click', () => this.toggle());
      this.addEventListener('mouseenter', () => this.scheduleOpen());
      this.addEventListener('mouseleave', () => this.scheduleClose());
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.close();
          this.trigger.focus();
        }
      });
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) this.close();
      });
      document.addEventListener('focusin', (e) => {
        if (!this.contains(e.target)) this.close();
      });
    }

    scheduleOpen() {
      if (window.matchMedia('(hover: none)').matches) return;
      clearTimeout(this.closeTimer);
      this.openTimer = setTimeout(() => this.open(), 80);
    }

    scheduleClose() {
      clearTimeout(this.openTimer);
      this.closeTimer = setTimeout(() => this.close(), 180);
    }

    toggle() {
      this.hasAttribute('open') ? this.close() : this.open();
    }

    open() {
      this.setAttribute('open', '');
      this.trigger.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.removeAttribute('open');
      this.trigger.setAttribute('aria-expanded', 'false');
    }
  }
  customElements.define('cw-mega-menu', CwMegaMenu);

  (function () {
    var toggle = document.querySelector('.cwh-mobile-toggle');
    var drawer = document.getElementById('cw-header-mobile-drawer');
    if (!toggle || !drawer) return;
    var summary = toggle.querySelector('summary');
    var closeBtn = drawer.querySelector('.cwh-drawer-close');

    function setState(isOpen) {
      if (isOpen) {
        toggle.setAttribute('open', '');
        drawer.hidden = false;
        document.body.style.overflow = 'hidden';
        var panel = drawer.querySelector('.menu-drawer');
        if (panel) panel.focus();
      } else {
        toggle.removeAttribute('open');
        drawer.hidden = true;
        document.body.style.overflow = '';
      }
    }

    setState(false);

    if (summary) {
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        setState(!toggle.hasAttribute('open'));
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        setState(false);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && toggle.hasAttribute('open')) {
        setState(false);
      }
    });

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) setState(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
